import { reactive } from 'vue'
import { defineStore } from 'vue_features/shared/composables/store_helpers.js'

function identifyDevice() {
  const userAgent = navigator.userAgent

  const supportsTouch = 'ontouchend' in document
  const isTabletDevice = /iPad|Macintosh|Android(?!.*mobile)/i.test(userAgent) && supportsTouch
  const isMobileDevice =
    /Android(.*mobile)|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || isTabletDevice

  return { isTabletDevice, isMobileDevice }
}

export const useGlobalStore = defineStore('global', () => {
  const state = reactive({
    locale: null,
    defaultOneTimeReturnToPath: '',
    isContentEmbedded: false,
    ...identifyDevice(),
  })

  return { state }
})
